import React from "react";
import { Link } from "react-router-dom";
import { CheckCircle, ArrowRight, Sparkle } from "@phosphor-icons/react";
import { useLandingT } from "@/lib/landingI18n";
import { LANDING } from "@/constants/landingTestIds";

const includes = [
  "priceInclude1",
  "priceInclude2",
  "priceInclude3",
  "priceInclude4",
  "priceInclude5",
  "priceInclude6",
];

export const PricingSection = ({ lang }) => {
  const t = useLandingT(lang);
  return (
    <section id="pricing" className="relative py-20 md:py-28 border-t border-white/8">
      <div className="max-w-[1240px] mx-auto px-5 md:px-8">
        <div className="max-w-2xl mx-auto text-center">
          <div className="kicker mx-auto">
            <span className="dot" />
            {t("pricingKicker")}
          </div>
          <h2 className="h-section mt-5 text-white">{t("pricingTitle")}</h2>
          <p className="mt-4 text-slate-400 text-base md:text-lg">
            {t("pricingSubtitle")}
          </p>
        </div>

        <div className="mt-14 max-w-2xl mx-auto">
          <div className="glass-strong rounded-3xl p-8 md:p-10 relative overflow-hidden neon-border">
            <div
              aria-hidden
              className="absolute -top-32 -end-32 w-80 h-80 rounded-full blur-3xl opacity-40"
              style={{
                background:
                  "radial-gradient(closest-side, rgba(16,185,129,0.55), transparent 70%)",
              }}
            />
            <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 relative">
              <div>
                <span className="inline-flex items-center gap-2 rounded-full bg-emerald-500/12 border border-emerald-500/30 px-3 py-1 text-[10px] uppercase tracking-[0.16em] text-emerald-300 font-medium">
                  <Sparkle size={12} weight="fill" />
                  Pro
                </span>
                <p className="mt-4 text-white text-2xl font-semibold tracking-tight">
                  Everything, unlocked.
                </p>
                <p className="text-slate-400 text-sm mt-1">
                  {t("pricingGuarantee")}
                </p>
              </div>
              <div className="text-start md:text-end">
                <div className="flex items-baseline gap-2 md:justify-end">
                  <span className="tabular text-6xl font-semibold text-white leading-none">
                    $19
                  </span>
                  <span className="text-slate-400 text-sm">{t("priceLabel")}</span>
                </div>
              </div>
            </div>

            <div className="mt-8 grid sm:grid-cols-2 gap-x-8 gap-y-3">
              {includes.map((k) => (
                <div key={k} className="flex items-start gap-2.5">
                  <CheckCircle
                    size={18}
                    weight="fill"
                    className="text-emerald-400 mt-0.5 shrink-0"
                  />
                  <span className="text-slate-200 text-sm">{t(k)}</span>
                </div>
              ))}
            </div>

            <div className="mt-8 flex flex-wrap items-center gap-3">
              <Link
                data-testid={LANDING.pricingCta}
                to="/app"
                className="btn-neon inline-flex items-center gap-2 px-6 py-3.5 rounded-xl text-sm md:text-base"
              >
                {t("pricingCta")}
                <ArrowRight size={16} weight="bold" className="flip-x" />
              </Link>
              <span className="text-slate-500 text-xs">
                Free forever · Upgrade any time
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
